import jwtAuthAxios from "services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const urlMasterWisuda = "v1/master/wisuda";
const urlMasterWisudaPeserta = "v1/master/wisuda-peserta";

export const findMasterWisudaById=createAsyncThunk ( "wisuda/findMasterWisudaById" , async ( val ) => {
    try {
        let token=await localStorage.getItem ( 'auth_token' );
        jwtAuthAxios.defaults.headers.common[ 'Authorization' ]=
            'Bearer ' + token;
        const url=`${urlMasterWisuda}/${val}`
        const response=await jwtAuthAxios.get ( url )
        return response.data
    } catch (response) {
        throw response
    }
} );
export const findMasterWisudaPesertaById=createAsyncThunk ( "wisuda/findMasterWisudaPesertaById" , async ( val ) => {
    try {
        let token=await localStorage.getItem ( 'auth_token' );
        jwtAuthAxios.defaults.headers.common[ 'Authorization' ]=
            'Bearer ' + token;
        const url=`${urlMasterWisudaPeserta}/${val}`
        const response=await jwtAuthAxios.get ( url )
        return response.data
    } catch (response) {
        throw response
    }
} );

export const findMasterWisudaPesertaByParam=createAsyncThunk ( "wisuda/findMasterWisudaPesertaByParam" , async ( val ) => {
    try {
        let token=await localStorage.getItem ( 'auth_token' );
        jwtAuthAxios.defaults.headers.common[ 'Authorization' ]=
            'Bearer ' + token;
        const url=`${urlMasterWisudaPeserta}/param`
        const response=await jwtAuthAxios.post ( url,val )
        return response.data
    } catch (response) {
        throw response
    }
} );

// params opsional: { id_periode, id_prodi } (ADMIN_PRODI selalu dibatasi ke prodinya di backend)
export const findMasterWisudaAll=createAsyncThunk ( "wisuda/findMasterWisudaAll" , async ( params ) => {
    try {
        let token=await localStorage.getItem ( 'auth_token' );
        jwtAuthAxios.defaults.headers.common[ 'Authorization' ]=
            'Bearer ' + token;
        const url=`${urlMasterWisuda}`
        const response=await jwtAuthAxios.get ( url , { params } )
        return response.data
    } catch (response) {
        throw response
    }
} );
export const findMasterWisudaPesertaAll=createAsyncThunk ( "wisuda/findMasterWisudaPesertaAll" , async (  ) => {
    try {
        let token=await localStorage.getItem ( 'auth_token' );
        jwtAuthAxios.defaults.headers.common[ 'Authorization' ]=
            'Bearer ' + token;
        const url=`${urlMasterWisudaPeserta}`
        const response=await jwtAuthAxios.get ( url )
        return response.data
    } catch (response) {
        throw response
    }
} );
export const upsertMasterWisuda=createAsyncThunk ( "skripsi/upsertMasterWisuda" , async ( val ) => {
    try {
        let token=await localStorage.getItem ( 'auth_token' );
        jwtAuthAxios.defaults.headers.common[ 'Authorization' ]=
            'Bearer ' + token;
        const url=`${urlMasterWisuda}`
        const response=await jwtAuthAxios.post( url , val )
        return response.data
    } catch (response) {
        throw response
    }
} );
export const upsertMasterWisudaPeserta=createAsyncThunk ( "skripsi/upsertMasterWisudaPeserta" , async ( val ) => {
    try {
        let token=await localStorage.getItem ( 'auth_token' );
        jwtAuthAxios.defaults.headers.common[ 'Authorization' ]=
            'Bearer ' + token;
        const url=`${urlMasterWisudaPeserta}`
        const response=await jwtAuthAxios.post ( url , val )
        return response.data
    } catch (response) {
        throw response
    }
} );
export const deleteMasterWisuda=createAsyncThunk ( "skripsi/deleteMasterWisuda" , async ( val ) => {
    try {
        let token=await localStorage.getItem ( 'auth_token' );
        jwtAuthAxios.defaults.headers.common[ 'Authorization' ]= 'Bearer ' + token;
        const url=`${urlMasterWisuda}/${val}`
        const response=await jwtAuthAxios.delete( url )
        return response.data
    } catch (response) {
        throw response
    }
} );
export const deleteMasterWisudaPeserta=createAsyncThunk ( "skripsi/deleteMasterWisudaPeserta" , async ( val ) => {
    try {
        let token=await localStorage.getItem ( 'auth_token' );
        jwtAuthAxios.defaults.headers.common[ 'Authorization' ]=
            'Bearer ' + token;
        const url=`${urlMasterWisudaPeserta}/${val}`
        const response=await jwtAuthAxios.delete( url )
        return response.data
    } catch (response) {
        throw response
    }
} );




const initialState = {
    loading: false,
    masterWisudaList : [],
    dataMasterWisuda : {},
    masterWisudaPesertaList : [],
    dataMasterWisudaPeserta : {},
}

const wisudaSlice = createSlice({
    name: "wisuda",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
            .addCase(deleteMasterWisudaPeserta.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteMasterWisudaPeserta.fulfilled, (state, action) => {
                state.dataMasterWisuda = action.payload;
                state.loading = false;
            })
            .addCase(deleteMasterWisudaPeserta.rejected, (state, action) => {
                state.loading = false;
            })
        builder
            .addCase(deleteMasterWisuda.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteMasterWisuda.fulfilled, (state, action) => {
                state.dataMasterWisuda = action.payload;
                state.loading = false;
            })
            .addCase(deleteMasterWisuda.rejected, (state, action) => {
                state.loading = false;
            })
        builder
            .addCase(upsertMasterWisudaPeserta.pending, (state) => {
                state.loading = true;
            })
            .addCase(upsertMasterWisudaPeserta.fulfilled, (state, action) => {
                state.dataMasterWisudaPeserta = action.payload;
                state.loading = false;
            })
            .addCase(upsertMasterWisudaPeserta.rejected, (state, action) => {
                state.loading = false;
            })
        builder
            .addCase(upsertMasterWisuda.pending, (state) => {
                state.loading = true;
            })
            .addCase(upsertMasterWisuda.fulfilled, (state, action) => {
                state.dataMasterWisuda = action.payload;
                state.loading = false;
            })
            .addCase(upsertMasterWisuda.rejected, (state, action) => {
                state.loading = false;
            })
        builder
            .addCase(findMasterWisudaPesertaAll.pending, (state) => {
                state.loading = true;
            })
            .addCase(findMasterWisudaPesertaAll.fulfilled, (state, action) => {
                state.masterWisudaPesertaList = action.payload;
                state.loading = false;
            })
            .addCase(findMasterWisudaPesertaAll.rejected, (state, action) => {
                state.loading = false;
            })
        builder
            .addCase(findMasterWisudaAll.pending, (state) => {
                state.loading = true;
            })
            .addCase(findMasterWisudaAll.fulfilled, (state, action) => {
                state.masterWisudaList = action.payload;
                state.loading = false;
            })
            .addCase(findMasterWisudaAll.rejected, (state, action) => {
                state.loading = false;
            })
        builder
            .addCase(findMasterWisudaPesertaById.pending, (state) => {
                state.loading = true;
            })
            .addCase(findMasterWisudaPesertaById.fulfilled, (state, action) => {
                state.dataMasterWisudaPeserta = action.payload;
                state.loading = false;
            })
            .addCase(findMasterWisudaPesertaById.rejected, (state, action) => {
                state.loading = false;
            })
        builder
            .addCase(findMasterWisudaById.pending, (state) => {
                state.loading = true;
            })
            .addCase(findMasterWisudaById.fulfilled, (state, action) => {
                state.dataMasterWisuda = action.payload;
                state.loading = false;
            })
            .addCase(findMasterWisudaById.rejected, (state, action) => {
                state.loading = false;
            })
        builder
            .addCase(findMasterWisudaPesertaByParam.pending, (state) => {
                state.loading = true;
            })
            .addCase(findMasterWisudaPesertaByParam.fulfilled, (state, action) => {
                state.masterWisudaPesertaList = action.payload;
                state.loading = false;
            })
            .addCase(findMasterWisudaPesertaByParam.rejected, (state, action) => {
                state.loading = false;
            })
        ;
    }
})
export const wisudaSelectors = (state) => state.wisuda;
export default wisudaSlice.reducer;